import { createSlice } from '@reduxjs/toolkit';

const i = [
    { key: 'videoDetails', title: 'Upload Video', state: 4, previousState: 4, subType: [] },
    {
    key: 'createVideos',
    title: 'Add Details',
    state: 4,
    previousState: 4,
    subType: [],
},
{ key: 'conceptAndChapter', title: 'Add Concept and Chapters', state: 4, previousState: 4, subType: [] },
{ title: 'Add Tags', key: 'tags', state: 4, previousState: 4, subType: [] }
]

const videoDetailsSlice = createSlice({
    name: 'VideoDetails',
    initialState: i,
    reducers: {
        addSubTypes: (state, actionType) => {
            const newState: any = {
                ...state[1],
                subType: [
                    ...actionType.payload,
                ]
            }
            state.splice(1, 1, newState);
        },
        updateCreateVideoState: (state, actionType) => {
            const nstate = state[1];
            state.splice(1, 1, {...nstate, ...actionType.payload});
        },
        removeSubTypes: (state, actionType) => {
            const newState: any = {
                ...state[1],
                subType: [
                    ...actionType.payload,
                ]
            }
            state.splice(1, 1, newState);
        },
        addExtraTags: (state, actionTypes) => {
            const tags: any = actionTypes.payload;
            state.splice(3, 1, tags);
        },
        addConceptAndChapter: (state, actionTypes) => {
            const concept = actionTypes.payload
            state.splice(2, 1, concept);
        },
        updateVideoStepState: (state, actionTypes) => {
            const videoUpload = actionTypes.payload
            state.splice(0, 1, videoUpload);
        },
    }
});

const { actions, reducer } = videoDetailsSlice;
export default reducer;
export const videoDetailsActions = actions;